import React from 'react'
import moment from 'moment'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import {
  JOURNEY_TIME_MILESTONES,
  getJourneyStatusTimes,
} from '../journeyWorkflow'

// Compact "Mobile 09:14 · On Scene 09:31 · With Patient 09:52 ..." strip built
// from journey.statusHistory. `dark` matches the dispatch screen styling;
// without it the strip renders for standard light pages (crew view, booking).
const JourneyTimesStrip = ({ journey, dark = false, dense = false }) => {
  const times = getJourneyStatusTimes(journey)
  const hasAnyTime = JOURNEY_TIME_MILESTONES.some(
    (milestone) => times[milestone.status],
  )

  if (!hasAnyTime) return null

  return (
    <Stack
      direction="row"
      flexWrap="wrap"
      columnGap={dense ? 0.75 : 1}
      rowGap={0.5}
      alignItems="center"
    >
      {JOURNEY_TIME_MILESTONES.map((milestone) => {
        const at = times[milestone.status]
        return (
          <Box
            key={milestone.status}
            sx={{
              px: dense ? 0.6 : 0.8,
              py: 0.3,
              borderRadius: 1,
              border: '1px solid',
              borderColor: dark
                ? at
                  ? 'rgba(134,239,172,0.28)'
                  : 'rgba(255,255,255,0.08)'
                : at
                  ? 'success.light'
                  : 'divider',
              backgroundColor: dark
                ? at
                  ? 'rgba(34,197,94,0.12)'
                  : 'rgba(255,255,255,0.03)'
                : at
                  ? 'rgba(46,125,50,0.08)'
                  : 'transparent',
            }}
          >
            <Typography
              component="span"
              sx={{
                fontSize: dense ? '0.66rem' : '0.7rem',
                fontWeight: 700,
                letterSpacing: 0.2,
                color: dark
                  ? at
                    ? 'rgba(226,232,240,0.85)'
                    : 'rgba(226,232,240,0.45)'
                  : at
                    ? 'text.primary'
                    : 'text.disabled',
              }}
            >
              {milestone.label}{' '}
            </Typography>
            <Typography
              component="span"
              sx={{
                fontSize: dense ? '0.7rem' : '0.74rem',
                fontWeight: 900,
                color: dark
                  ? at
                    ? '#86EFAC'
                    : 'rgba(226,232,240,0.35)'
                  : at
                    ? 'success.main'
                    : 'text.disabled',
              }}
            >
              {at ? moment(at).format('HH:mm') : '--:--'}
            </Typography>
          </Box>
        )
      })}
    </Stack>
  )
}

export default JourneyTimesStrip
